'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactDom = require('react-dom');

class NodeResolver extends _react.Component {
  componentDidMount() {
    this.props.innerRef((0, _reactDom.findDOMNode)(this));
  }
  componentWillUnmount() {
    this.props.innerRef(null);
  }
  render() {
    return this.props.children;
  }
}
exports.default = NodeResolver;